import React from "react";
import styled from "styled-components";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Desc, Question, Wrapper } from "./styled";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage2 = ({ setScreen }: Props) => {
  const ANSWER = 5;
  const { select, onClickItem } = useSelect(ANSWER);
  return (
    <Container>
      <Question>
        국기를 개양하지 않아도
        <br />
        되는 날을 고르시오.
      </Question>

      <AnswerContainer>
        <Wrapper onClick={() => onClickItem(1)} $incorrect={select === 1}>
          <Text>⓵ 3·1절</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 제헌절</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(3)} $incorrect={select === 3}>
          <Text>⓷ 광복절</Text>
          {select === 3 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(4)} $incorrect={select === 4}>
          <Text>⓸ 개천절</Text>
          {select === 4 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(5)} $correct={!!select}>
          <Text>⓹ 4·19 혁명기념일</Text>
        </Wrapper>
        <Wrapper onClick={() => onClickItem(6)} $incorrect={select === 6}>
          <Text>⓺ 한글날</Text>
          {select === 6 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={3}
          setScreen={setScreen}
          desc={
            <Desc>
              대한민국국기법에 따르면, 5대 국경일(3·1절, 제헌절, 광복절, 개천절,
              한글날)과 현충일, 국군의 날은 국기를 다는 날로 지정되어 있다
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage2;

const AnswerContainer = styled.div``;

const Text = styled.div`
  font-size: 30px;
`;
